import axiosInstance from "../Instance/axiosInstance";

export const GetAllEmployees = () => {
  return axiosInstance.get("/admin/employees");
};

export const CreateEmployee = (data) => {
  return axiosInstance.post("/admin/employee/create", data);
};

export const UpdateEmployee = (id, data) => {
  return axiosInstance.put(`/admin/employee/${id}`, data);
};


export const DeleteEmployee = (id) => {
  return axiosInstance.delete(`/admin/employee/${id}`);
};